import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text mb-2 font-medium" }
const _hoisted_2 = { class: "text-black/70" }

import { PropType } from "vue";

import { useNews } from "@/use/useNews";

import NewsPostVoting from "./NewsPostVoting.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsPost',
  props: {
  // eslint-disable-next-line no-undef
  post: { type: Object as PropType<Post>, required: true },
},
  setup(__props) {

const props = __props



const { votePost } = useNews();

async function onVote(variants: number[]) {
  votePost(props.post.id, variants);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(__props.post.date), 1),
    _createElementVNode("p", _hoisted_2, _toDisplayString(__props.post.text), 1),
    (__props.post.voting)
      ? (_openBlock(), _createBlock(NewsPostVoting, {
          key: 0,
          onVote: onVote,
          voting: __props.post.voting,
          class: "mt-6"
        }, null, 8, ["voting"]))
      : _createCommentVNode("", true)
  ]))
}
}

})